import script from "./manage-groups.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-groups.vue?vue&type=script&setup=true&lang=js"

import "./manage-groups.vue?vue&type=style&index=0&id=3c53a326&lang=css"

const __exports__ = script;

export default __exports__